import {Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges} from "@angular/core";
import {CssVarHelper} from "./css-var.helper";
import {Subscription} from "rxjs";
import {SessionEvents} from "../orchestration/session-events";

@Directive({
    selector: "[woa-css-var]"
})
export class CssVarDirective implements OnChanges, OnDestroy {
    @Input("woa-css-var") cssVars: any = {};

    private subscriptions: Subscription = new Subscription();

    constructor(private element: ElementRef) {
        this.subscriptions.add(SessionEvents.currentApp$.subscribe(() => {
            this.applyVars();
        }));
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.cssVars) {
            this.applyVars();
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    private applyVars(): void {
        CssVarHelper.applyVars(this.element.nativeElement, this.cssVars);
    }
}



// WEBPACK FOOTER //
// ./src/app/html-utils/css-var.directive.ts